<div class="modal-users" *ngIf="translateModal && translateModal?.nameUpdate">
  <div class="modal-users__header" *ngIf="rootViewTitle">
    <span class="modal-users__header__title">
      {{ translateModal.nameUpdate }}
    </span>
    <div class="modal-users__header__close">
      <mat-icon (click)="dialogRef.close()" class="">close</mat-icon>
    </div>
  </div>
  <div class="modal-users__body" *ngIf="formUser?.value">
    <form action="" [formGroup]="formUser">
      <div class="modal-users__body__names">
        <div class="modal-users__body__names__avatar">
          <label for=""> {{ translateModal.avatar }} </label>
          <div
            class="modal-users__body__names__avatar__content"
            [ngClass]="{ 'open-menu-avatar': isMenuOpen }"
          >
            <div
              class="modal-users__body__names__avatar__content__textAvatar"
              *ngIf="srcData === ''"
            >
              <mat-icon>photo_camera</mat-icon>
              <span> {{ translateModal.addPhoto }} </span>
            </div>
            <div
              class="modal-users__body__names__avatar__content__textAvatar active-edit-avatar"
              *ngIf="srcData !== ''"
              [matMenuTriggerFor]="menu"
            >
              <mat-icon>photo_camera</mat-icon>
              <span>{{ translateModal.editPhoto }}</span>
              <mat-menu #menu="matMenu" [class]="'menu-avatar-mg'">
                <button mat-menu-item (click)="openLoadImage()">
                  {{ translateModal.loadPhoto }}
                </button>
                <button mat-menu-item (click)="srcData = ''">
                  {{ translateModal.deletePhoto }}
                </button>
              </mat-menu>
            </div>
            <img
              *ngIf="srcData === ''"
              class="modal-users__body__names__avatar__content__img"
              src="https://s3.amazonaws.com/cdn.mango-soft.com/access-control/person-placeholder.png"
            />
            <img
              *ngIf="srcData !== ''"
              src="{{ srcData }}"
              onerror="this.onerror=null;this.src='https://s3.amazonaws.com/cdn.mango-soft.com/access-control/person-placeholder.png';"
              class="modal-users__body__names__avatar__content__img"
            />
            <zf-s3-upload-image
              [version]="'1'"
              [url]="
                'https://res.cloudinary.com/du4jrqkyo/image/upload/v1549938954/picture.jpg'
              "
              [urlPresigned]="
                'https://api-services.mango-soft.com/stage/get-presigned-url'
              "
              [bucket]="'cdn.mango-soft.com'"
              [folder]="'access-control/files'"
              [client]="'zerofractal'"
              [imageZoom]="false"
              (tokenId)="tokenId = $event"
              (urlUploaded)="urlUploadedHandle($event)"
            ></zf-s3-upload-image>
          </div>
        </div>
        <div class="modal-users__body__names__form">
          <div class="form-group">
            <label for="fullName">
              {{ translateModal.fullName || "Fullname" }}
              <span class="asteriks">*</span></label
            >
            <input
              type="text"
              id="fullName"
              class="input-mg-app"
              [placeholder]="translateModal.placeholderFullName"
              formControlName="fullName"
            />
            <div
              *ngIf="f['fullName'].touched && f['fullName'].invalid"
              class="alert-error"
            >
              <div *ngIf="f['fullName'].errors!['required']">
                {{ translateModal.fullnameRequired }}
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="username">
              {{ translateModal.username || "Username" }}
              <span class="asteriks">*</span></label
            >
            <input
              type="text"
              id="username"
              class="input-mg-app"
              [placeholder]="translateModal.placeholderUsername"
              formControlName="username"
            />
            <div
              *ngIf="f['username'].touched && f['username'].invalid"
              class="alert-error"
            >
              <div *ngIf="f['username'].errors!['required']">
                {{ translateModal.usernameRequired }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="email">
          {{ translateModal.email || "Email" }}
          <span class="asteriks">*</span></label
        >
        <input
          type="email"
          id="email"
          class="input-mg-app"
          [placeholder]="translateModal.email"
          formControlName="email"
        />
        <div
          *ngIf="f['email'].touched && f['email'].invalid"
          class="alert-error"
        >
          <div *ngIf="f['email'].errors!['required']">
            {{ translateModal.emailRequired }}
          </div>
          <div *ngIf="f['email'].errors!['email']">
            {{ translateModal.emailRequired }}
          </div>
        </div>
      </div>

      <div class="profiles" [formGroup]="formProfile" *ngIf="rootViewProfile">
        <ng-container formArrayName="profile">
          <div
            class="form-group"
            *ngFor="let item of fields.controls; let index = index"
            [formGroupName]="index"
          >
            <label for=""> {{ item.value["key"] | titlecase }} </label>
            <input
              type="text"
              *ngIf="item.value['key'] !== 'address'"
              [placeholder]="translateModal?.placeholderValue"
              class="input-mg-app"
              formControlName="value"
            />
            <div class="input-group-mg" *ngIf="item.value['key'] === 'address'">
              <input
                [placeholder]="'Address'"
                formControlName="value"
                class="input-mg-app input-address"
              />
              <div class="input-group-mg-append">
                <button
                  class="mg-button-input btn mg-input text-white"
                  type="button"
                  (click)="openAddressModal()"
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="passwords">
        <div class="form-group">
          <label for="password">
            {{ translateModal.password }}
            <span class="asteriks">*</span></label
          >
          <div class="input-password">
            <input
              [type]="type"
              class="input-mg-app"
              [placeholder]="translateModal.placeholderPassword"
              formControlName="password"
              autocomplete="new-password"
            />
            <mat-icon
              class="icon-password"
              (click)="type = type === 'password' ? 'text' : 'password'"
              >{{
                type == "password" ? "visibility_off" : "visibility"
              }}</mat-icon
            >
          </div>
          <div
            *ngIf="f['password'].touched && f['password'].invalid"
            class="alert-error"
          >
            <div *ngIf="f['password'].errors!['required']">
              {{ translateModal.passwordRequired }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="confirmPassword">
            {{ translateModal.confirmPassword }}
            <span class="asteriks">*</span></label
          >
          <div class="input-password">
            <input
              [type]="type2"
              class="input-mg-app"
              [placeholder]="translateModal.placeholderConfirmPassword"
              formControlName="confirmPassword"
              autocomplete="new-password"
            />
            <mat-icon
              class="icon-password"
              (click)="type2 = type2 === 'password' ? 'text' : 'password'"
              >{{
                type2 == "password" ? "visibility_off" : "visibility"
              }}</mat-icon
            >
          </div>
          <div
            *ngIf="f['confirmPassword'].touched && f['confirmPassword'].invalid"
            class="alert-error"
          >
            <div *ngIf="f['confirmPassword'].errors!['required']">
              {{ translateModal.confirmPasswordRequired }}
            </div>
            <div
              *ngIf="
                f['confirmPassword'].errors!['confirmedValidator'] &&
                !f['confirmPassword'].errors!['required']
              "
            >
              {{ translateModal.confirmPasswordNotMatch }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div
    *ngIf="loading"
    style="
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <div class="loader" style="padding: 2px">
      <span class="loader-input"></span>
    </div>
  </div>
  <div class="footer-modal modalAction" *ngIf="formUser?.value">
    <button (click)="dialogRef.close()" class="mg-button secundaryButton">
      Cancel
    </button>
    <button
      (click)="save()"
      class="mg-button primaryButton"
      [disabled]="formUser.invalid"
    >
      Save
    </button>
  </div>
</div>
